import React, { useState, useRef } from 'react';
import { Plus, Image, FileText, Film, Paperclip } from 'lucide-react';

const FileUploadMenu = ({ onFileSelect }) => {
  const [showMenu, setShowMenu] = useState(false);
  const fileInputRef = useRef(null);
  const [uploadType, setUploadType] = useState('image');

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      
      if (uploadType !== 'any' && !allowedExtensions[uploadType].includes(`.${fileExtension}`)) {
        alert(`Invalid file type. Please select a valid ${uploadType} file.`);
        return;
      }
      onFileSelect(file);
      setShowMenu(false);
    }
  };

  const triggerFileInput = (type) => {
    fileInputRef.current.value = null;
    setUploadType(type);
    setTimeout(() => {
      fileInputRef.current.click();
    }, 0);
  };

  const allowedExtensions = {
    image: ['.jpg', '.jpeg', '.png', '.gif', '.webp'],
    document: ['.pdf', '.doc', '.docx', '.txt', '.xls', '.xlsx', '.csv'],
    video: ['.mp4', '.avi', '.mov', '.mkv'],
    any: []
  };

  return (
    <div className="relative" style={{ marginRight: '10px' }}>
      <button
        onClick={() => setShowMenu(!showMenu)}
        style={{
          padding: '8px',
          borderRadius: '50%',
          border: 'none',
          background: '#404040',
          color: '#e4e6eb',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '40px',
          height: '40px'
        }}
      >
        <Plus style={{ width: '20px', height: '20px' }} />
      </button>

      {showMenu && (
        <div style={{
          position: 'absolute',
          bottom: '50px',
          left: '0',
          background: '#2a2f32',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
          padding: '8px',
          width: '200px'
        }}>
          <button
            onClick={() => triggerFileInput('image')}
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              padding: '8px',
              border: 'none',
              borderRadius: '4px',
              background: 'transparent',
              color: '#e4e6eb',
              cursor: 'pointer',
              hover: { background: '#404040' }
            }}
          >
            <Image style={{ width: '20px', height: '20px', marginRight: '8px' }} />
            <span>Image</span>
          </button>
          
          <button
            onClick={() => triggerFileInput('document')}
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              padding: '8px',
              border: 'none',
              borderRadius: '4px',
              background: 'transparent',
              color: '#e4e6eb',
              cursor: 'pointer',
              hover: { background: '#404040' }
            }}
          >
            <FileText style={{ width: '20px', height: '20px', marginRight: '8px' }} />
            <span>Document</span>
          </button>
          
          <button
            onClick={() => triggerFileInput('video')}
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              padding: '8px',
              border: 'none',
              borderRadius: '4px',
              background: 'transparent',
              color: '#e4e6eb',
              cursor: 'pointer',
              hover: { background: '#404040' }
            }}
          >
            <Film style={{ width: '20px', height: '20px', marginRight: '8px' }} />
            <span>Video</span>
          </button>
          
          <button
            onClick={() => triggerFileInput('any')}
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              padding: '8px',
              border: 'none',
              borderRadius: '4px',
              background: 'transparent',
              color: '#e4e6eb',
              cursor: 'pointer',
              hover: { background: '#404040' }
            }}
          >
            <Paperclip style={{ width: '20px', height: '20px', marginRight: '8px' }} />
            <span>Other</span>
          </button>
        </div>
      )}

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        accept={uploadType !== 'any' ? allowedExtensions[uploadType].join(',') : ''}
        onChange={handleFileSelect}
      />
    </div>
  );
};

export default FileUploadMenu;